import React from "react";
import styles from "./style.module.scss";

const HomeCardTitle = ({ title = "", renderExtra = () => {} }) => {
  return (
    <div className={styles.titleContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.verticalDivider} />
        <div className={styles.title}>{title}</div>
      </div>
      {renderExtra()}
    </div>
  );
};

export default HomeCardTitle;
